import React from "react";

function Loading() {
  return (
    <div className="mt-[35vh] lg:mt-[25vh] text-white text-[5em]  animate-pulse m-auto">
      <span>LOADING...</span>
    </div>
  );
}

export default Loading;
